// Mirrors EuUdiVersion.cs: version "<major>.<minor>", major = the linked Basic UDI regulation
const REGULATION_BY_MAJOR = [null, "MDD", "AIMDD", "IVDD", "MDR", "IVDR"];

// 0 when there is no Basic UDI or its regulation is None / Unknown
export const euUdiMajorFor = (applicableRegulation) => {
    const major = REGULATION_BY_MAJOR.indexOf((applicableRegulation ?? "").trim().toUpperCase());
    return major > 0 ? major : 0;
};

export const parseEuUdiVersion = (version) => {
    const parts = (version ?? "").split(".");
    if (parts.length !== 2 || parts.some(p => p === "" || isNaN(Number(p))))
        return null;
    return { major: Number(parts[0]), minor: Number(parts[1]) };
};
